import slide1 from "./assets/slide-01.jpg";
import slide2 from "./assets/slide-02.jpg";
import slide3 from "./assets/slide-03.jpg";

export const MAINSLIDE = [
  {
    id: 11,
    image: slide1,
    title: "Elden Ring",
    titleStyle: "animate__fadeInUp animate__fadeOut",
    titleActive: "animate__fadeInUp",
    available: "Available ON PS5",
    availableStyle: "animate__fadeInDown animate__fadeOut",
    availableActive: "animate__fadeInDown",
    btn: "Get Now",
    btnStyle: "animate__zoomIn animate__fadeOut",
    btnActive: "animate__zoomIn",
  },
  {
    id: 22,
    image: slide2,
    title: "The Last of Us Part 2",
    titleStyle: "animate__lightSpeedInRight animate__fadeOut",
    titleActive: "animate__lightSpeedInRight",
    available: "Available Now",
    availableStyle: "animate__rollIn animate__fadeOut",
    availableActive: "animate__rollIn",
    btn: "Get Now",
    btnStyle: "animate__jackInTheBox animate__fadeOut",
    btnActive: "animate__jackInTheBox",
  },
  {
    id: 33,
    image: slide3,
    title: "Nier:Automata",
    titleStyle: "animate__rotateInUpRight animate__fadeOut",
    titleActive: "animate__rotateInUpRight",
    available: "Top Rated",
    availableStyle: "animate__rotateInDownLeft animate__fadeOut",
    availableActive: "animate__rotateInDownLeft",
    btn: "Get Now",
    btnStyle: "animate__rotateIn animate__fadeOut",
    btnActive: "animate__rotateIn",
  },
];

export const HOMEPAGE3 = [
  {
    id: 11,
    image: slide1,
    title: "Elden Ring",
  },
  {
    id: 22,
    image: slide2,
    title: "The Last of Us",
  },
  {
    id: 33,
    image: slide3,
    title: "Nier:Automata",
  },
];
